{
  "pt_BR": "centro-da-cidade",
  "cs_CZ": "centrum-mesta",
  "da_DK": "bycentrum",
  "de_DE": "stadtzentrum",
  "en_GB": "city-centre",
  "es_ES": "centro-de-la-ciudad",
  "fi_FI": "kaupungin-keskusta",
  "fr_FR": "centre-ville",
  "it_IT": "centro-citta",
  "ja_JP": "shinai",
  "ko_KR": "siti-senteo",
  "nl_NL": "stadscentrum",
  "nb_NO": "by-sentrum",
  "pl_PL": "centrum-miasta",
  "pt_PT": "centro-da-cidade",
  "ru_RU": "city-centre",
  "sv_SE": "stadskarnan",
  "tr_TR": "sehir-merkezi",
  "zh_CN": "chengshi-zhongxin"
}
